import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ILoginCredentials } from '../../models/credentials.model';
import { ErrorMessageUtils } from '../../utils/ErrorMessageUtils';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertSeverity } from '../../ui/alert.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginComponent {
  email = new FormControl('', [Validators.required, Validators.email], []);
  password = new FormControl('', [Validators.required]);
  loginForm: FormGroup = new FormGroup({
    email: this.email,
    password: this.password,
  });
  inSubmission: boolean = false;
  showAlert: boolean = false;
  severity: AlertSeverity = 'info';
  message: string = '';

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    if (this.activatedRoute.snapshot.paramMap.get('showEmailVerifiedMessage')) {
      this.showAlert = true;
      this.severity = 'success';
      this.message = 'Email geverifieerd! Je kan nu inloggen.';
    }
    if (
      this.activatedRoute.snapshot.paramMap.get(
        'showEmailNotYetVerifiedMessage',
      )
    ) {
      this.showAlert = true;
      this.severity = 'info';
      this.message = 'Controleer je email om je account te activeren.';
    }
    if (this.activatedRoute.snapshot.paramMap.get('showLoggedOutMessage')) {
      this.showAlert = true;
      this.severity = 'success';
      this.message = 'Je bent succesvol uitgelogd.';
    }
    if (this.activatedRoute.snapshot.paramMap.get('showEmailChangedMessage')) {
      this.showAlert = true;
      this.severity = 'success';
      this.message =
        'Je e-mailadres is aangepast. Log in met je nieuwe e-mailadres.';
    }
    if (
      this.activatedRoute.snapshot.paramMap.get('showEmailChangeFailedMessage')
    ) {
      this.showAlert = true;
      this.severity = 'error';
      this.message =
        'De link is vervallen of het nieuwe e-mailadres is al in gebruik. Probeer het opnieuw via Mijn gegevens.';
    }
    if (
      this.activatedRoute.snapshot.paramMap.get('showAccountDeletedMessage')
    ) {
      this.showAlert = true;
      this.severity = 'success';
      this.message = 'Je account en gegevens zijn verwijderd.';
    }
    const email = localStorage.getItem('emailForSignIn');
    if (email) {
      this.loginForm.get('email')?.setValue(email);
    }
  }

  async loginUser() {
    this.inSubmission = true;
    try {
      await this.authService.loginUser(
        this.loginForm.value as ILoginCredentials,
      );
      this.inSubmission = false;
      this.showAlert = true;
      this.severity = 'success';
      this.message = 'Login succes!';
      setTimeout(() => {
        this.router.navigateByUrl(this.destination());
      }, 500);
    } catch (error: any) {
      await this.authService.logoutUserWithoutRedirect();
      this.inSubmission = false;
      this.showAlert = true;
      this.severity = 'error';
      this.message =
        ErrorMessageUtils.determineFrontendMessageBasedOnError(error);
    }
  }

  /** Where to go once signed in: the page a guard bounced them off, otherwise the
   *  reserve flow. Only a path on this site is accepted, so a returnUrl handed out in
   *  a mail cannot forward a member to somewhere else after they type their password. */
  private destination(): string {
    const asked = this.activatedRoute.snapshot.queryParamMap.get('returnUrl');
    return asked && /^\/(?!\/)/.test(asked) ? asked : '/reserveer';
  }

  navigateToRegister(): void {
    this.router.navigateByUrl('/aanmelden');
  }

  navigateToResetPassword() {
    this.router.navigateByUrl('/paswoord-vergeten');
  }
}
